import { KeyValue } from "./keyvalue";

export class KBA {
  public SecretQuestion1: KeyValue;
  public SecretAnswer1: string;
  public SecretQuestion2: KeyValue;
  public SecretAnswer2: string;
}
